var redefine = require('../internals/redefine');

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/redefine-all.js
// module id = 93
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35